{
  "accessDenied": "رسائی مسترد",
  "action": "Action",
  "active": "فعال",
  "address": "ایڈریس",
  "amount": "رقم",
  "appName": "ایگزالٹ ایکسچینج",
  "apply": "Apply",
  "approved": "منظور شدہ",
  "available": "دستیاب",
  "back": "واپس",
  "balance": "بیلنس",
  "cancel": "Cancel",
  "cancelled": "کینسلڈ",
  "cardProviderRequired": "پرووائیڈر انضمام درکار ہے",
  "cardProviderRequiredDescription": "ایگزالٹ کارڈ ابھی دستیاب نہیں ہے۔ اس فیچر کو استعمال کرنے سے پہلے ایک حقیقی کارڈ جاری کرنے والا پرووائیڈر منسلک ہونا ضروری ہے۔",
  "close": "بند کریں",
  "closed": "بند",
  "coin": "کوائن",
  "comingSoon": "جلد آ رہا ہے",
  "completed": "مکمل",
  "confirm": "تصدیق کریں",
  "continue": "جاری رکھیں",
  "copy": "کاپی کریں",
  "copyFailed": "کاپی ناکام ہو گئی۔",
  "copyright": "جملہ حقوق محفوظ ہیں۔",
  "country": "ملک",
  "currency": "کرنسی",
  "date": "تاریخ",
  "delete": "Delete",
  "description": "Description",
  "details": "تفصیلات",
  "disabled": "غیر فعال",
  "download": "ڈاؤن لوڈ کریں",
  "edit": "ترمیم کریں",
  "email": "ای میل",
  "enabled": "فعال",
  "error": "خرابی",
  "exaltCard": "ایگزالٹ کارڈ",
  "exchange": "ایکسچینج",
  "failed": "ناکام",
  "fast": "تیز",
  "fillAllRequiredFields": "تمام ضروری معلومات درج کریں۔",
  "gated": "محدود",
  "global": "Global",
  "inactive": "غیر فعال",
  "information": "معلومات",
  "invalidRequest": "غلط درخواست۔",
  "language": "زبان",
  "languagePreferences": "زبان کی ترجیحات",
  "loading": "لوڈ ہو رہا ہے...",
  "locked": "Locked",
  "lockedBalance": "مقفل بیلنس",
  "name": "نام",
  "network": "نیٹ ورک",
  "networkError": "نیٹ ورک خرابی۔",
  "next": "اگلا",
  "no": "نہیں",
  "noAssetsFound": "کوئی اثاثہ نہیں ملا۔",
  "noDataFound": "کوئی ڈیٹا نہیں ملا۔",
  "noResultsFound": "کوئی نتیجہ نہیں ملا۔",
  "noRewardsYet": "ابھی تک کوئی ری وارڈ نہیں۔",
  "noRewardsYetDescription": "حقیقی ریفرل اور اسٹیکنگ ری وارڈز یہاں ظاہر ہوں گے جب آپ انہیں کمائیں گے۔",
  "notAvailable": "دستیاب نہیں",
  "notVerified": "ویریفائی نہیں ہوا",
  "note": "نوٹ",
  "notificationCenter": "اطلاعات",
  "open": "اوپن",
  "openStatus": "کھلا",
  "pending": "پینڈنگ",
  "permissionRequired": "آپ کو یہ عمل انجام دینے کی اجازت نہیں ہے۔",
  "phone": "فون",
  "pleaseLoginFirst": "براہ کرم پہلے لاگ اِن کریں۔",
  "price": "قیمت",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "reference": "حوالہ",
  "referralProgram": "ریفرل",
  "refresh": "ریفریش",
  "refreshing": "ریفریش ہو رہا ہے...",
  "rejected": "ریجیکٹڈ",
  "remove": "ہٹائیں",
  "requestFailed": "درخواست ناکام ہوگئی۔",
  "rewardsCenter": "ری وارڈز سینٹر",
  "rewardsUnavailable": "فی الحال آپ کے ری وارڈز لوڈ نہیں ہو سکے۔",
  "role": "رول",
  "save": "محفوظ کریں",
  "saving": "محفوظ ہو رہا ہے...",
  "search": "تلاش کریں",
  "searchAssets": "اثاثے تلاش کریں",
  "secure": "محفوظ",
  "sending": "بھیجا جا رہا ہے...",
  "serverError": "سرور میں خرابی۔",
  "servicesHub": "خدمات",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "spot": "اسپاٹ",
  "status": "اسٹیٹس",
  "submit": "جمع کروائیں",
  "submitting": "جمع کیا جا رہا ہے...",
  "success": "کامیاب",
  "system": "سسٹم",
  "time": "وقت",
  "token": "ٹوکن",
  "total": "کل",
  "transactionHash": "ٹرانزیکشن ہیش",
  "type": "قسم",
  "uid": "یو آئی ڈی",
  "unauthorized": "غیر مجاز",
  "unlocked": "Unlocked",
  "update": "اپ ڈیٹ کریں",
  "upload": "اپ لوڈ کریں",
  "user": "یوزر",
  "userId": "یوزر آئی ڈی",
  "value": "قیمت",
  "verified": "ویریفائیڈ",
  "view": "دیکھیں",
  "viewAllNotifications": "تمام اطلاعات دیکھیں",
  "wallet": "Wallet",
  "walletAddress": "والٹ ایڈریس",
  "warning": "انتباہ",
  "yes": "ہاں"
}